
import React, { useState, useEffect } from 'react'; 
import { useNavigate } from 'react-router-dom'; 
import { auth } from '../firebase'; // Import Firebase auth
import { onAuthStateChanged } from 'firebase/auth'; // Import the auth state listener
import LanguageFilter from './LanguageFilter';
import DifficultyFilter from './DifficultyFilter';
import { FaCrown, FaChalkboardTeacher, FaMagic, FaCode, FaHandPointer } from 'react-icons/fa';
import { SignInModal, SignUpModal } from './Header'; 
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
} from 'firebase/auth';


const Sidebar = ({ language, setLanguage, difficulty, setDifficulty, isPremium }) => {
  const navigate = useNavigate();
 
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState('signIn'); 
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track if user is logged in

  useEffect(() => {
    // Check authentication state on component mount
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setIsLoggedIn(true); // User is signed in
      } else {
        setIsLoggedIn(false); // User is signed out
      }
    });

    return () => unsubscribe(); // Cleanup subscription on unmount
  }, []);

  const closeModal = () => {
    setShowModal(false);
    setError('');
  };

  const handleOpenSignIn = () => {
    setShowModal(true);
    setActiveTab('signIn');
  };

  const handleOpenSignUp = () => {
    setShowModal(true);
    setActiveTab('signUp');
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    try {
      await createUserWithEmailAndPassword(auth, email, password);
      alert('User registered successfully!');
      closeModal();
    } catch (error) {
      setError(error.message);
    }
  };

  const handleSignIn = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert('User signed in successfully!');
      closeModal();
      navigate('/checkout'); // Navigate to checkout page after signing in
    } catch (error) {
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      alert('Signed in with Google!');
      closeModal();
      navigate('/checkout'); // Navigate to checkout page after signing in
    } catch (error) {
      setError(error.message);
    }
  };

  const handleNavigateToCheckout = () => { 
    if (isLoggedIn) {
      navigate('/checkout'); // Navigate directly to checkout page if user is logged in
    } else {
      handleOpenSignIn(); // Open sign-in modal if user is not logged in
    }
  };

  return (
    <div className="sidebar">
      <LanguageFilter language={language} setLanguage={setLanguage} />
      <DifficultyFilter difficulty={difficulty} setDifficulty={setDifficulty} />

      {/* Non-Premium Section */}
      {!isPremium && (
        <div className="challenge-info">
        <div className="price-tag">
          <span>Sale</span>
        </div>
        <h3 className="animated-title"> 
  <span className="crown-emoji">👑</span> Premium Membership
</h3>
<p><span className="icon-bounce">✅</span> <strong>Lifetime Access:</strong> Unlock all current 7000+ Challenges.</p>
<p><span className="icon-bounce">✅</span> <strong>One-time Payment:</strong> One Time payment Lifetime Access</p>
<p><span className="icon-bounce">✅</span> <strong>Exclusive Features:</strong> Get access to all future content and features.</p>
<p><span className="icon-bounce">✅</span> <strong>Complete Control:</strong> Screenshot and Save Challenges</p>
        <button className="premium-btn" onClick={handleNavigateToCheckout}>
          <FaCrown /> Get Lifetime Access
        </button>
      </div>
      
      )}
       
       {!isLoggedIn && (
        <div className="sign-up-section" style={{ display: 'none' }}>
          <button className="sign-up-btn" onClick={handleOpenSignUp}>
            Sign Up
          </button>
        </div>
      )} 
      {isPremium && (
           <div 
           className="challenge-info-premium" 
           style={{
             backgroundColor: '#f9f9f9',
             padding: '20px',
             borderRadius: '8px',
             boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
             maxWidth: '800px',
             margin: 'auto',
             fontFamily: 'Arial, sans-serif',
             color: '#333',
           }}
         >
           <h3 
             className="animated-title" 
             style={{
               color: '#2d3e50',
               fontSize: '24px',
               fontWeight: '600',
               display: 'flex',
               alignItems: 'center',
               gap: '8px',
             }}
           >
             <FaChalkboardTeacher style={{ color: '#ff8c00' }} />
             <h3>Enjoy Challenges </h3>
           </h3>
           <p 
             style={{
               fontSize: '18px',
               margin: '10px 0',
               display: 'flex',
               alignItems: 'center',
               gap: '8px',
             }}
           >
             <FaMagic 
               className="icon-bounce" 
               style={{
                 fontSize: '20px',
                 color: '#4caf50',
                 
               }} 
             />
             <strong style={{ color: '#2d3e50' }}>Read:</strong> Check the task description and hints.
           </p>
           <p 
             style={{
               fontSize: '18px',
               margin: '10px 0',
               display: 'flex',
               alignItems: 'center',
               gap: '8px',
             }}
           >
             <FaCode 
               className="icon-bounce" 
               style={{
                 fontSize: '20px',
                 color: '#2196f3',
                 
               }} 
             />
             <strong style={{ color: '#2d3e50' }}>Code:</strong> Write the function to solve the problem.
           </p>
           <p 
             style={{
               fontSize: '18px',
               margin: '10px 0',
               display: 'flex',
               alignItems: 'center',
               gap: '8px',
             }}
           >
             <FaHandPointer 
               className="icon-bounce" 
               style={{
                 fontSize: '20px',
                 color: '#ff5722',
                 
               }} 
             />
             <strong style={{ color: '#2d3e50' }}>Test:</strong> Run the test cases to validate your solution.
           </p>
         </div>
        
      )}
      {/* Render Modals */}
      {showModal && (
        <div className="modal">
          {activeTab === 'signIn' ? (
            <SignInModal
              closeModal={closeModal}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleSignIn={handleSignIn}
              handleGoogleSignIn={handleGoogleSignIn}
              error={error}
              setActiveTab={setActiveTab}
            />
          ) : (
            <SignUpModal
              closeModal={closeModal}
              username={username}
              setUsername={setUsername}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleSignUp={handleSignUp}
              handleGoogleSignIn={handleGoogleSignIn}
              error={error}
              setActiveTab={setActiveTab}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Sidebar;
